class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    const mainSelf = this;
    this.buildProductObject(); // Default Products & List
    this.cachedResults = {};
    this.isOpen = false;
    this.isMobile = window.innerWidth < 768 ? true : false;
    this.buildSelectors();
    this.setModalPosition();
    this.setupEventListeners();
    this.initialRender(false);
  }

  setModalPosition() {
    this.isMobile = window.innerWidth < 768 ? true : false;
    const modelData = this.getResultsMaxHeight();
    if (this.isMobile) {
      this.style.setProperty('--modelTopPos', modelData.announcementBottom + 'px');
      this.style.setProperty('--modelMaxHeight', '100vh');
      this.predictiveSearchResults.style.setProperty('--productContainerMaxHeight', '100%');
    } else {
      const productContainerMaxHeight = window.innerHeight - modelData.modelTopPos - 130;
      this.style.setProperty('--modelTopPos', modelData.modelTopPos + 'px');
      this.style.setProperty('--modelMaxHeight', modelData.modelMaxHeight + 'px');
      this.predictiveSearchResults.style.setProperty(
        '--productContainerMaxHeight',
        productContainerMaxHeight + 'px'
      );
    }
  }

  buildProductObject() {
    const defaultConfig = window._theme.headerSearch || null;
    if (!defaultConfig) {
      return;
    }

    this.defaultConfig = defaultConfig;
    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts || [];

    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.map((product) => {
      const product_url = `/products/${product.handle}`;

      // Process variants with proper metafield data
      const variants = product.variants.map((variant, index) => {
        // Ensure metafield data is properly structured
        const metafieldValue =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.brightperl_variant_inventory
            ? variant.metafields.custom.brightperl_variant_inventory
            : '';

        const expressShippingAllow =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.allow_express_shipping
            ? variant.metafields.custom.allow_express_shipping
            : '';

        return {
          ...variant,
          available: variant.available ? '1' : '0',
          image_alt: variant.featured_image ? variant.featured_image.alt : '',
          image_link: variant.featured_image ? variant.featured_image.src : '',
          link: `${product_url}?variant=${variant.id}`,
          list_price: variant.compare_at_price ? variant.compare_at_price / 100 : null,
          price: variant.price / 100,
          quantity_total: variant.inventory_quantity || 0,
          sku: variant.sku || '',
          taxable: variant.taxable ? '1' : '0',
          variant_id: variant.id,
          // Add the metafield data structure that the shipping-info component expects
          search_variant_metafields_data: {
            variant_metafield_69f1d8722b9c470908fa53fe850945fb: metafieldValue,
            variant_metafield_070071a13a8ea5aafeb0b99afa0c101f: expressShippingAllow,
          },
        };
      });

      return {
        ...product,
        product_id: product.id,
        link: `/products/${product.handle}`,
        image_link: product.featured_image,
        shopify_images: product.images || [],
        tags: product.tags.join('[:ATTR:]'),
        list_price: product.compare_at_price / 100,
        price: product.price / 100,
        shopify_variants: variants,
      };
    });

    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.filter(
      (p) => p.available
    );

    delete window._theme.headerSearch;
  }

  buildSelectors() {
    this.model = this.querySelector('[data-ajax-search-results]');
    this.input = this.querySelector('input[data-header-search]');
    this.form = this.input.closest('form');
    this.formResetBtn = this.form.querySelector('[type="reset"]');
    this.predictiveSearchResults = this.querySelector('[data-search-products]');
    this.predictiveSearchViewAllBtn = this.querySelector('[data-search-view-all]');
    this.overlay = document.querySelector('.wrapper-overlay');
    this.closeSearchBtns = this.querySelectorAll('[data-close-search]');

    this.trendingSearcheList = this.querySelectorAll('[data-list-trending-searches]');
    this.brandsList = this.querySelectorAll('[data-list-brands]');
    this.suggestionList = this.querySelectorAll('[data-list-suggestions]');
    this.pagesList = this.querySelectorAll('[data-list-pages]');

    this.noResultTextNodes = this.querySelectorAll('[data-noresult-block] span');
    this.searchIcons = document.querySelectorAll('[data-trigger-header-search]');
    this.newHeadSearch = document.querySelector('[data-new-head-search]');
  }

  setupEventListeners() {
    const self = this;
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.form.addEventListener('reset', (evt) => {
      this.setAttribute('data-result', false);
      this.predictiveSearchViewAllBtn.classList.add('hidden');
      this.close();
      if (this.controller) this.controller.abort();
      if (window.innerWidth < 768) {
        setTimeout(() => {
          this.newHeadSearch.focus();
        }, 200);
      }
    });

    this.closeSearchBtns.forEach((btn) => {
      btn.addEventListener('click', function (evt) {
        self.close(true);
      });
    });

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.addEventListener('blur', this.onFocusOut.bind(this));

    this.predictiveSearchViewAllBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      const term = self.getQuery();
      window.location.href = '/pages/search-results-page?q=' + encodeURIComponent(term);
    });

    // this.addEventListener('keyup', this.onKeyup.bind(this));
    // this.addEventListener('keydown', this.onKeydown.bind(this));
    this.searchIcons.forEach((triggerElem) => {
      triggerElem.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.open();
        this.input.focus();
      });

      // triggerElem.addEventListener('keydown', evt => {
      //   if (evt.key === 'Enter' || evt.key === ' ') {
      //     evt.preventDefault();
      //     this.open();
      //     this.input.focus();
      //   }
      // });
    });

    window.onresize = debounce((evt) => {
      this.setModalPosition();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange(event) {
    this.input.removeAttribute('aria-invalid');
    this.removeAttribute('data-empty');
    const searchTerm = this.getQuery();
    this.noResultTextNodes.forEach((elem) => (elem.innerHTML = '\"' + searchTerm + '\"'));
    this.form.querySelector('input[name="q"]').value = searchTerm;
    if (!searchTerm.length) {
      this.setAttribute('data-result', false);
      this.initialRender();
      this.setLiveRegionText('found top trending searches & prodducts');
      return;
    }

    this.setAttribute('data-result', true);
    this.getSearchResults(searchTerm, event);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  onFocus(event) {
    this.open();
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm, event);
    }
  }

  onFocusOut(evt) {
    const relatedTarget = evt.relatedTarget;
    const isInsideModal = this.contains(evt.target);
    // const isInsideForm = this.form.contains(evt.target);
    // const isSearchIcon = this.searchIcon.contains(evt.target) || this.searchIcon === evt.target;
    setTimeout(() => {
      if (!isInsideModal) this.close();
      if (relatedTarget && !this.contains(relatedTarget)) this.close();
      // if (!isInsideModal && !isInsideForm && !isSearchIcon) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm, event) {
    const queryKey = searchTerm.toLowerCase();
    this.setLiveRegionLoadingState();

    const cachedRes = this.cachedResults[queryKey];
    if (cachedRes) {
      if (cachedRes.totalItems === 0) this.renderEmptyResult(cachedRes, event);
      else this.renderSearchResults(cachedRes);
      return;
    }

    if (this.controller) this.controller.abort();

    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.form.setAttribute('data-loading', true);
    const maxSuggestion = this.isMobile ? 4 : 6;

    const menTags = ['Gender_Men', 'gender_men', 'Gender_men', 'gender_Men', 'GENDER_Men'];
    const womenTags = [
      'Gender_women',
      'Gender_Women',
      'gender_Women',
      'gender_women',
      'GENDER_Women',
    ];
    const searchTerms = queryKey ? queryKey.trim().toLowerCase().split(' ') : [];
    let tagQuery = '';
    if (searchTerms.includes('women') || searchTerms.includes('woman'))
      tagQuery = '&restrictBy[snize_facet1]=' + womenTags.join('|');
    else if (searchTerms.includes('men') || searchTerms.includes('man'))
      tagQuery = '&restrictBy[snize_facet1]=' + menTags.join('|');
    else tagQuery = '';

    const BASE_URL =
      'https://searchserverapi.com/getwidgets?api_key=4R1a4a6e9W&output=jsonp&items=true&maxResults=8&suggestions=true&suggestionsMaxResults=' +
      maxSuggestion +
      '&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5' +
      tagQuery; // restrictBy%5Bquantity%5D=1%7C&

    fetch(`${BASE_URL}&q=${encodeURIComponent(searchTerm)}`, { signal })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((res) => {
        this.cachedResults[queryKey] = res;
        if (res.totalItems === 0) this.renderEmptyResult(res, event);
        else this.renderSearchResults(res);
        this.controller = null;
      })
      .catch((error) => {
        // this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.form.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  initialRender(openModel = true) {
    if (!this.defaultConfig) return;
    this.setAttribute('data-result', false);
    let trendingSearchesHtml = '',
      productsHtml = '';

    if (this.defaultConfig.defaultSuggestions.length)
      trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);

    if (this.defaultConfig.defaultProducts.length)
      productsHtml = this.buildProductGrid(
        this.defaultConfig.defaultProducts.slice(0, 10),
        this.defaultConfig.productTypes.slice(0, 10)
      );

    if (trendingSearchesHtml !== '') {
      this.trendingSearcheList.forEach((list) => {
        list
          .closest('.search-result-col-row')
          .classList.toggle('hidden', trendingSearchesHtml === '');
        list.innerHTML = trendingSearchesHtml;
      });
    }

    if (productsHtml !== '') this.predictiveSearchResults.innerHTML = productsHtml;
    this.predictiveSearchViewAllBtn.classList.add('hidden');
    this.form.removeAttribute('data-loading');
    if (openModel) this.open();

    // Initialize shipping info components for default products
    this.initializeShippingInfoComponents();
  }

  renderSearchResults(res) {
    if (!res.totalItems || res.totalItems === 0) return;
    this.removeAttribute('data-empty');
    const totalProducts = res.totalItems;
    const brandsHtml = this.buildBrandsList(res.categories);
    const suggestionsHtml = this.buildSuggestionList(res.suggestions);
    const trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);
    const pagesHtml = this.buildPagesList(res.pages);
    const productsHtml = this.buildProductGrid(res.items.slice(0, 12));

    // Left :: List
    this.brandsList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', brandsHtml === '');
      list.innerHTML = brandsHtml;
    });

    this.suggestionList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', suggestionsHtml === '');
      list.innerHTML = suggestionsHtml;
    });

    this.trendingSearcheList.forEach((list) => {
      list
        .closest('.search-result-col-row')
        .classList.toggle('hidden', trendingSearchesHtml === '');
      list.innerHTML = trendingSearchesHtml;
    });

    this.pagesList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', pagesHtml === '');
      list.innerHTML = pagesHtml;
    });

    // Right :: Products
    this.predictiveSearchResults.innerHTML = productsHtml;
    this.predictiveSearchViewAllBtn.innerHTML = 'View All ' + totalProducts + ' Products';

    this.setAttribute('results', true);
    this.setLiveRegionResults(totalProducts);
    if (totalProducts > 8) this.predictiveSearchViewAllBtn.classList.remove('hidden');
    else this.predictiveSearchViewAllBtn.classList.add('hidden');

    this.form.removeAttribute('data-loading');
    this.open();

    // Initialize shipping info components after rendering
    this.initializeShippingInfoComponents();
  }

  renderEmptyResult(res, event) {
    if (event && event.type !== 'focus') {
      const searchTerm = this.getQuery();
      _theme.track.trackData({ event: 'zero_search_dropdown', search_term: searchTerm });
    }

    this.input.setAttribute('aria-invalid', true);
    this.setLiveRegionText('Sorry, nothing found for the search term ' + this.getQuery());
    this.setAttribute('data-empty', true);
    this.initialRender(false);
    // if(res.totalItems > 0) return;
    // this.form.removeAttribute('data-loading');
    // this.open();
  }

  updateHtml(html, str, data) {
    let newhtml = html;
    if (newhtml.indexOf(str) > -1) {
      newhtml = newhtml.replace(str, data);
      return this.updateHtml(newhtml, str, data);
    } else {
      return newhtml;
    }
  }

  buildBrandsList(brands) {
    if (!brands || brands.length === 0) return '';
    let mainHtml = '<ul class="brand-list" role="list">';
    brands.slice(0, 1).forEach(function (brand) {
      let brand_content = '';
      if (brand.image_link != '') {
        brand_content = `<span class="brand-img"><img src="${brand.image_link}" alt="${brand.title}"></span>`;
      } else {
        brand_content = `<span class="brand-title">${brand.title}</span>`;
      }

      mainHtml +=
        '<li class="brand-item" role="listitem"><a href="' +
        brand.link +
        '">' +
        brand_content +
        '<span class="see-all">See all products</span></a></li>';
    });

    return mainHtml;
  }

  buildSuggestionList(suggestions) {
    if (!suggestions || suggestions.length === 0) return '';
    let mainHtml = '<ul role="list">';
    suggestions.slice(0, 3).forEach(function (suggestion) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="/pages/search-results-page?q=' +
        encodeURI(suggestion) +
        '">' +
        suggestion +
        '</a></li>';
    });

    return mainHtml;
  }

  buildPagesList(pages) {
    if (!pages || pages.length === 0) return '';
    const pagesArr = pages.filter((page) => page.link.includes('/blogs/')).slice(0, 3);
    if (pagesArr.length === 0) return '';
    let mainHtml = '<ul role="list">';
    pagesArr.forEach(function (page) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="' +
        page.link +
        '">' +
        page.title +
        '</a></li>';
    });

    return mainHtml;
  }

  buildProductGrid(products, productTypes) {
    if (!products || products.length === 0) return '';
    const self = this;
    let mainHtml = '';

    // Check if the global product HTML template is available
    if (!_theme.product_html || !_theme.product_html.productGridSearch) {
      return '';
    }

    products.map(function (product, productIndex) {
      let product_html = _theme.product_html.productGridSearch;
      let vid = '';
      const variant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];

      const variant_barcode_available = product.shopify_variants
        .filter((variant) => {
          return variant.available == true || variant.available == 1 || variant.available == '1';
        })
        .map((variant) => ({
          barcode: variant.barcode,
          available: variant.available, // Optional (since we already filtered)
          brightperlInventory:
            variant?.search_variant_metafields_data
              ?.variant_metafield_69f1d8722b9c470908fa53fe850945fb,
          allowExpressShipping:
            variant?.search_variant_metafields_data
              ?.variant_metafield_070071a13a8ea5aafeb0b99afa0c101f,
        }));

      const maxDiscountData = getMaxDiscountAndvariant(product);
      const productUrl =
        (maxDiscountData.availableMaxDiscountVariant &&
          maxDiscountData.availableMaxDiscountVariant.link) ||
        product.link;

      if (!variant) vid = product.shopify_variants[0].variant_id;
      else vid = variant.variant_id;
      let prodType = '';
      if (product.metafield_528ce274002b8ca7943429b22b64b453 != undefined) {
        prodType = product.metafield_528ce274002b8ca7943429b22b64b453;
      }
      if (product.metafield_9e14d49086f4ac1134f463aa2738d80e != undefined) {
        prodType = product.metafield_9e14d49086f4ac1134f463aa2738d80e;
      }
      if (productTypes) {
        prodType = productTypes[productIndex];
      }

      product_html = self.updateHtml(product_html, '[[Product_Id]]', product.product_id);

      // Safely update shipping info variants with error handling
      try {
        if (_theme.Helpers && _theme.Helpers.updateHtml) {
          product_html = _theme.Helpers.updateHtml(
            product_html,
            '[[shipping_info_variants]]',
            JSON.stringify(variant_barcode_available)
          );
        } else {
          product_html = self.updateHtml(
            product_html,
            '[[shipping_info_variants]]',
            JSON.stringify(variant_barcode_available)
          );
        }
      } catch (error) {
        product_html = self.updateHtml(
          product_html,
          '[[shipping_info_variants]]',
          JSON.stringify(variant_barcode_available)
        );
      }
      product_html = self.updateHtml(product_html, '[[Product_Title]]', product.title);
      product_html = self.updateHtml(product_html, '[[Product_Type]]', prodType);
      product_html = self.updateHtml(product_html, '[[Variant_Id]]', vid);
      product_html = self.updateHtml(product_html, '[[Product_URL]]', productUrl);
      const featured_image =
        product.image_link ||
        'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
      const image =
        "<img loading='lazy' src='" +
        featured_image +
        "' alt='" +
        product.title +
        "' class='lazyload' />";
      product_html = self.updateHtml(product_html, '[[Product_Image_1]]', image);
      if (product.shopify_images && product.shopify_images.length > 1) {
        const image_2 =
          "<a tabindex='-1' href='" +
          productUrl +
          "' class='images-two'><img src='" +
          product.shopify_images[1] +
          "' alt='" +
          product.title +
          "' class='lazyload' loading='lazy' /></a>";
        product_html = self.updateHtml(product_html, '[[Product_Image_2]]', image_2);
        product_html = self.updateHtml(product_html, '[[Image_1_Class]]', 'images-one');
      } else {
        product_html = self.updateHtml(product_html, '[[Image_1_Class]]', '');
        product_html = self.updateHtml(product_html, '[[Product_Image_2]]', '');
      }

      const p_html = buildDiscountLabel(product);

      // if(productIndex <= 1 ){
      //   const checkForLabels = buildLabels(product);

      //   if(checkForLabels || buildDiscountLabel(product) ){
      //     product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', "");
      //   }else{
      //     // product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', buildCustomLabel("Bestseller"));
      //   }
      // }else{
      //   product_html = self.updateHtml(product_html, '[[Product_Custom_Label]]', "");
      // }

      product_html = self.updateHtml(product_html, '[[Product_Vendor]]', product.vendor || '');
      product_html = self.updateHtml(
        product_html,
        '[[Product_Vendor_Url]]',
        '/collections/' + self.handleize(product.vendor) || ''
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Handle]]',
        product.link.replace('/products/', '')
      );
      product_html = self.updateHtml(product_html, '[[Grid_Class]]', buildGridClass(product));
      product_html = self.updateHtml(product_html, '[[Product_Price]]', buildPrice(product));
      // product_html = self.updateHtml(product_html, '[[Product_Labels]]', buildLabels(product));
      // product_html = self.updateHtml(product_html, '[[Product_PriceOff_Label]]', buildPriceOffLabels(product));
      product_html = self.updateHtml(
        product_html,
        '[[Product_LabelsWithLimit]]',
        buildLabelsWithLimit(product, self),
      );
      product_html = self.updateHtml(product_html, '[[Product_Notify_CTA]]', ''); //buildNotify(product)
      // product_html = self.updateHtml(product_html, '[[Product_Quick_Add_Swatch]]', ''); //buildQuickAddSwatch(product)
      if (typeof p_html === 'string') {
        // product_html = self.updateHtml(product_html, '[[Product_Bogo_Label]]', p_html);
        product_html = self.updateHtml(product_html, '[[MIXMATCH_CLASS]]', '');
      } else {
        // product_html = self.updateHtml(product_html, '[[Product_Bogo_Label]]', p_html.html);
        product_html = self.updateHtml(
          product_html,
          '[[MIXMATCH_CLASS]]',
          p_html.mixmatch ? 'has-mixmatch' : ''
        );
      }

      mainHtml += product_html;
    });

    function isTimerActive(timerSettings) {
      if (
        !timerSettings.enabled ||
        !timerSettings.startDate ||
        !timerSettings.startTime ||
        !timerSettings.endDate ||
        !timerSettings.endTime
      ) {
        return false;
      }

      // Get current time in EST/EDT
      const currentDateEST = _theme.Helpers.getCurrentESTTime();

      const startDateTime = _theme.Helpers.parseESTDate(timerSettings.startDate, timerSettings.startTime).getTime();
      const endDateTime = _theme.Helpers.parseESTDate(timerSettings.endDate, timerSettings.endTime).getTime();

      const isActive = currentDateEST >= startDateTime && currentDateEST <= endDateTime;

      return isActive;
    }

    function buildLabelsWithLimit(product, mainSelf) {
      let html = '';
      let hasBundle = false;
      let badgeCount = parseInt(0);
      const productTags = product.tags.trim().toLowerCase().split('[:attr:]');

      // Filter variants that have flash sale metafield with value 'true' and are available
      const flashVariants = product.shopify_variants.filter(
        (variant) =>
          variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
          variant?.available !== '0'
      );

      // Check if timer is active and flash sale extension shop metafield is active
      const timerSettings = window.countdownTimerSettings || {};
      const isTimerActiveCheck = isTimerActive(timerSettings);
      const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;
      
      // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
      if (flashVariants.length > 0 && isTimerActiveCheck && flashSaleExtensionActive) {
        const startDate = timerSettings.startDate || '';
        const startTime = timerSettings.startTime || '';
        const endDate = timerSettings.endDate || '';
        const endTime = timerSettings.endTime || '';

        html += `<div class='offer-tag-style flash-sale product-tag-style' role='status' aria-label='Flash sale promotion'><span class='flash-sale-wrapper'><img alt="Flash Sale Icon" src="//fragrancemarket.com/cdn/shop/files/flash-icon.png?v=11919913765476859936">Flash Sale</span> <span class='flash-separator' aria-hidden='true'></span> <countdown-timer data-start-date='${startDate}' data-start-time='${startTime}' data-end-date='${endDate}' data-end-time='${endTime}' data-replace-days-with-hours='${window.replace_days_with_hours}' data-location='product-grid' role='timer' aria-live='polite' aria-label='Flash sale countdown timer' tabindex='0'><span class='flash-timer-text'>00:00:00</span></countdown-timer></div>`;
        badgeCount = badgeCount + parseInt(1);
      }

      // Check if timer is active and flash sale extension shop metafield is active
      if (flashVariants.length > 0 && isTimerActiveCheck && flashSaleExtensionActive) {
        const per = Math.round(parseFloat(flashVariants[0].list_price) - parseFloat(flashVariants[0].price));
        html += `
              <span class="badge price__badge-sale">
                <span class="noun-discount">
                  <img src="//fragrancemarket.com/cdn/shop/files/noun-discount.svg?v=16528122525495080232" alt="discount"></span> $${per} Off <span class="visually-hidden"> Discount</span>      
              </span>`;
        badgeCount = badgeCount + parseInt(1);
      } else {
        const maxDiscountData = getMaxDiscountAndvariant(product);
        if (maxDiscountData.maxDiscount && maxDiscountData.maxDiscount > 0) {
          html += `<span class="new-tag-style blue-badge-style">Save Up To $${maxDiscountData.maxDiscount}</span>`;
          badgeCount = badgeCount + parseInt(1);
        }

        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;
      
        // Check if variant metafield structure exists and has available offer variant
        const hasMetafieldStructure = product.shopify_variants?.some(
            variant => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );
        
        // Check if any variant has is_offer_applicable = "true" (string) AND available !== "0"
        const hasOfferVariant = hasMetafieldStructure && product.shopify_variants?.some(
            v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && v.available !== "0"
        );
        
        if (productOffer === '2 For $99' && hasOfferVariant) {
          html +=
            '<span class="customOff new blue-badge-style">' +
            '2 for $99' +
            ' | Mix &amp; Match</span>';
          hasBundle = true;
          badgeCount = badgeCount + parseInt(1);
        }
      }

      if (productTags && productTags.length > 0) {
        if (productTags.includes('bogo-discount') && hasBundle == false && badgeCount < 2) {
          html += '<span class="new-tag-style badge-style">BOGO 50% OFF</span>';
          badgeCount = badgeCount + parseInt(1);
        }

        if (productTags.includes('online-only-item') && badgeCount < 2) {
          html += '<span class="new-tag-style badge-style">Online Only</span>';
          badgeCount = badgeCount + parseInt(1);
        }

        if (productTags.includes('best-sellers') && badgeCount < 2) {
          html += '<span class="new-tag-style badge-style">Best Seller</span>';
        }
      }

      return html;
    }

    function buildLabels(product) {
      let html = '';

      const variant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];
      if (!variant || Number(product.quantity) === 0 || product.quantity_total === '') {
        html += '<div class="new-tag-style soldout">Out of stock</div>';
      }

      if (!product.tags) return html;
      const tags = product.tags.split('[:ATTR:]');
      tags.map(function (tag) {
        const tag_dcase = tag.trim().toLowerCase();
        if (tag_dcase === 'new') {
          html += '<div class="new-tag-style">New!</div>';
        }
      });

      return html;
    }

    function buildPriceOffLabels(product) {
      // Number(product.discount) && Number(product.discount) > 0 || (product.list_price > product.price)
      let html = '';
      const maxDiscountData = getMaxDiscountAndvariant(product);
      if (!maxDiscountData.maxDiscount) return '';
      const per = maxDiscountData.maxDiscount;
      const variant = maxDiscountData.maxDiscountVariant;
      if (!variant) return '';

      html =
        '<div class="price-box">' +
        '<div class="price-regular">' +
        '<span class="custom-discount text pink_color" data-old-price="' +
        variant.list_price +
        '" data-current-price="' +
        variant.price +
        '">' +
        '<span class="text">Save up to  $' +
        per +
        '</span>' +
        '</span>' +
        '</div>' +
        '</div>';

      return html;
    }

    function buildDiscountLabel(product) {
      let html = '';
      if (product.tags && product.tags != '') {
        const tags = product.tags.split('[:ATTR:]');
        tags.map(function (tag) {
          const tag_dcase = tag.trim().toLowerCase();
          if (tag_dcase === 'discount-amount') {
            const discount_per = tag_dcase.split(':')[1];
            html +=
              '<p class="customOff new">Buy 1 get 1 at ' +
              discount_per +
              '% off<br>Mix & Match</p>';
          }
        });
        
        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;

          // Check if variant metafield structure exists and has available offer variant
        const hasMetafieldStructure = product.shopify_variants?.some(
            variant => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );
        
        // Check if any variant has is_offer_applicable = "true" (string) AND available !== "0"
        const hasOfferVariant = hasMetafieldStructure && product.shopify_variants?.some(
            v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && v.available !== "0"
        );
        
        if (productOffer === '2 For $99' && hasOfferVariant) {
          const offerhtml =
            '<div class="offer-wrapper fix-bottom">' +
            '<p class="customOff new">Buy ' +
            '2 for $99' +
            ' | Mix &amp; Match</p>' +
            '</div>';
          html = {
            html: offerhtml,
            mixmatch: true,
          };
        }
        tags.map(function (tag) {
          const tag_dcase = tag.trim().toLowerCase();
          if (tag_dcase === 'bogo-discount') {
            html +=
              '<div class = "price-box">' +
              '<div class="price-regular">' +
              '<span class = "bogoTextContainer">' +
              '<span class="text">BOGO</span><span class="discount_text">50% OFF</span>' +
              '</span>' +
              '</div>' +
              '</div>';
          }
        });
      }
      return html;
    }

    function buildPrice(product) {
      let isSoldOut = false;
      const variant = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      })[0];
      const prices = product.shopify_variants.map(function (v) {
        return Number(v.price);
      });
      if (!variant) isSoldOut = true;

      const price = Shopify.formatMoney(product.price * 100, window.money_format);
      const list_price = Shopify.formatMoney(product.list_price * 100, window.money_format);
      let html =
        '<div><span class="sale-price pink_color"><span class="visually-hidden">Sale price ' +
        price +
        '</span><span aria-hidden="true">' +
        price +
        '</span></span><span class="price-item--regular"><span class="visually-hidden">Regular price ' +
        list_price +
        '</span><span aria-hidden="true">' +
        list_price +
        '</span></span></div>';
      if (prices.length > 1) {
        const min_price = Math.min.apply(null, prices);
        const max_price = Math.max.apply(null, prices);
        if (min_price !== max_price) {
          const min_price_formatted = Shopify.formatMoney(min_price * 100, window.money_format);
          const max_price_formatted = Shopify.formatMoney(max_price * 100, window.money_format);
          html =
            '<div class="sale-price pink_color"><span class="visually-hidden">Price range from ' +
            min_price_formatted +
            ' to ' +
            max_price_formatted +
            '</span><span aria-hidden="true">' +
            min_price_formatted +
            ' - ' +
            max_price_formatted +
            '</span></div>';
        }
      }

      // if(isSoldOut) html = '';
      return html;
    }

    function buildGridClass(product) {
      let html = '';
      const available_v = product.shopify_variants.filter(function (v) {
        return JSON.parse(v.available);
      });
      if (available_v.length) html = 'available';
      else html = 'sold_out';

      return html;
    }

    function getMaxDiscountAndvariant(product) {
      let maxDiscount = 0,
        maxDiscountVariant = null;
      let availableMaxDiscount = 0,
        availableMaxDiscountVariant = null;
      product.shopify_variants &&
        product.shopify_variants.length > 0 &&
        product.shopify_variants.forEach(function (v) {
          const maxPrice = Number(v.list_price);
          if (!maxPrice || maxPrice <= 0) return false;
          const price = Number(v.price);
          const discountPer = Math.ceil(maxPrice - price);
          if (discountPer > maxDiscount) {
            maxDiscount = discountPer;
            maxDiscountVariant = v;
          }
          if (discountPer > availableMaxDiscount && Number(v.available)) {
            availableMaxDiscount = discountPer;
            availableMaxDiscountVariant = v;
          }
        });

      const discountAmt = Number(product.discount);
      const productListPrice = Number(product.list_price);
      if (!maxDiscount && discountAmt > 0 && productListPrice > 0) {
        const per = Math.floor(product.list_price - product.price);
        maxDiscount = discountAmt || per;
      }

      return {
        maxDiscount: maxDiscount,
        maxDiscountVariant: maxDiscountVariant,
        availableMaxDiscount: availableMaxDiscount,
        availableMaxDiscountVariant: availableMaxDiscountVariant,
      };
    }

    return mainHtml;
  }

  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  setLiveRegionResults(totalProducts) {
    const searchTerm = this.getQuery();
    this.removeAttribute('loading');
    this.setLiveRegionText(totalProducts + ' products found for the search term ' + searchTerm);
  }

  getResultsMaxHeight() {
    const announcementBottom = document
      .getElementById('shopify-section-announcement-bar')
      .getBoundingClientRect().bottom;
    const modelTopPos = document
      .getElementById('shopify-section-navigation')
      .getBoundingClientRect().bottom;
    this.resultsMaxHeight = window.innerHeight - modelTopPos;
    return {
      modelMaxHeight: this.resultsMaxHeight,
      modelTopPos: modelTopPos,
      announcementBottom: announcementBottom,
    };
  }

  open() {
    document.body.classList.add('search-active', 'overflow-hidden');
    this.formResetBtn.setAttribute('tabindex', 0);
    this.setAttribute('open', true);
    this.isOpen = true;
    this.setModalPosition();
    _theme.focusTrap(
      $(this),
      () => {
        this.close(true);
      },
      null,
      { disableLinearNavigation: true, enableBackwardJourney: true }
    );
  }

  close(clearSearchTerm) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
    // this.overlay.classList.remove('active');
    document.body.classList.remove('search-active', 'overflow-hidden');
    this.form.removeAttribute('data-loading');
    this.isOpen = false;
  }

  initializeShippingInfoComponents() {
    // Initialize shipping info components after search results are rendered
    const shippingInfoElements = this.querySelectorAll('shipping-info');

    shippingInfoElements.forEach((element, index) => {
      // Force re-initialization of shipping info components
      if (element.connectedCallback) {
        element.connectedCallback();
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) {
    const hsw = document.querySelector('header.site-header .customer-links.search');
    const hs = document.querySelector('header-search');
    hsw && hs && hsw.append(hs);
  }
  if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
    const searchWrap = document.querySelector('.main-menu .header-seach-wrap');
    const mbArea = document.querySelector('.main-menu .mb-area');
    searchWrap && mbArea && mbArea.parentElement.insertBefore(searchWrap, mbArea);
  }
  customElements.define('header-search', HeaderSearch);
});